module.exports = __webpack_public_path__ + "media/images/el_español_que_hablamos-27c6ffcbb98f3529a98ff9246faa1081.png";